// extracted by mini-css-extract-plugin
export default {"tariffTable":"TariffTable_tariffTable__8szA8"};